import { render, staticRenderFns } from "./add_holiday_form.vue?vue&type=template&id=7f141856"
import script from "./add_holiday_form.vue?vue&type=script&lang=js"
export * from "./add_holiday_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports